import React, { useState } from "react";
import { message as AndMessage, Upload, Spin } from "antd";
import success from "../../../assets/png/success.png";
import uploadImg from "../../../assets/png/uploadImg.png";
import { uploadmedia, profilesetting } from "../../../fetch/api/login";

const SetInformation = ({ toChooseTeam, ChooseTeam }) => {
  const [imageUrl, setImageUrl] = useState();
  const [fileList, setFileList] = useState([]);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const beforeUpload = (file) => {
    setImageUrl(window.URL.createObjectURL(file));
    setFileList([file]);
    return false;
  };
  const uploadButton = (
    <div className="w-full h-full rounded-[100%] p-[15px] overflow-hidden">
      <img className="  w-full h-full" src={uploadImg} alt="" />
    </div>
  );
  const uploadImage = () => {
    return new Promise((resolve, reject) => {
      let uploadForm = new FormData();
      uploadForm.append("image_file[]", fileList[0]);
      uploadForm.append("type", "avatar");
      uploadmedia(uploadForm).then((res) => {
        if (res) {
          const { code, data, message } = res;
          if (code == 200) {
            resolve(data[0]);
          } else {
            reject(message);
          }
        }
      });
    });
  };
  return (
    <Spin spinning={loading}>
      <div className="flex flex-col items-center h-full w-full ">
        <div className="mt-[15px] text-[13.5897px] font-bold">
          Complete your profile
        </div>
        <div className=" mt-[20px]">
          <Upload
            name="avatar"
            listType="picture-circle"
            className="loginmodalUpload"
            showUploadList={false}
            maxCount="1"
            beforeUpload={beforeUpload}
          >
            {imageUrl ? (
              <img
                src={imageUrl}
                alt=""
                className="w-full h-full border-none rounded-[100%]"
              />
            ) : (
              uploadButton
            )}
          </Upload>
        </div>
        <Upload
          name="avatar"
          showUploadList={false}
          maxCount="1"
          beforeUpload={beforeUpload}
        >
          <div className=" mt[3.2px] text-[12px] scale-[calc(8.7_/_12)] text-[#283AC6] underline">
            Upload Image (required)
          </div>
        </Upload>
        <div className=" flex items-center w-[219px] border border-[#BDBDBD] overflow-hidden h-[33px] rounded-[5px] font-semibold  mt-[19px] pl-[5px] pr-[5px]">
          <div className="flex-1 h-full ">
            <input
              maxLength="16"
              className="outline-0 w-full h-full text-[12px] font-medium placeholder:scale-[calc(6.53_/_12)] placeholder:origin-left"
              placeholder="Choose username"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </div>
          {name.length === 0 ? (
            <span className="text-[12px] scale-[calc(6.53_/_12)] text-[#BDBDBD]">
              *required
            </span>
          ) : (
            <div className="flex h-full items-center">
              <span className="scale-[calc(7.64_/_12)] text-[12px] text-[#C4C4C4]">
                {name.length}/16
              </span>
              <img src={success} alt="" />
            </div>
          )}
        </div>
        <div
          className={`w-[219px] h-[30px] text-white  flex items-center justify-center rounded-[57px] m-auto mt-[17px]  cursor-pointer ${
            fileList.length > 0 && name ? "bg-[#09B251]" : "bg-[#BDBDBD]"
          }`}
          onClick={() => {
            setLoading(true);
            if (fileList.length > 0 && !!name) {
              uploadImage()
                .then((res) => {
                  let userInfo = {
                    username: name,
                    avatar: res.image,
                  };
                  profilesetting(userInfo).then((res) => {
                    if (res) {
                      const { code, data, message } = res;
                      if (code == 200) {
                        localStorage.setItem("login", JSON.stringify(data));
                        toChooseTeam();
                      } else {
                        AndMessage.error({
                          content: message,
                          maxCount: 1,
                        });
                      }
                      setLoading(false);
                    }
                  });
                })
                .catch((error) => {
                  setLoading(false);
                  AndMessage.error({
                    content: error,
                    maxCount: 1,
                  });
                });
            }
          }}
        >
          <span className="scale-[calc(9.16_/_12)] text-[12px] font-semibold">
            CONTINUE
          </span>
        </div>
      </div>
    </Spin>
  );
};
export default SetInformation;
